export default __webpack_public_path__ + "static/media/resume.bc382d73.pdf";